<template>
<div class="flex justify-end items-center w-1/2 relative">
  <div
    class="relative align-left outline-none leading-8"
    tabindex=0
    @blur="open = false"

  >
    <div
      class="bg-beige-academy-100 text-chocolate-academy-600 pl-4 w-64
            cursor-pointer pr-10 border border-blue-academy-600"
      :class="{open: open}"
      @click="open = !open"
    >
      {{selected}}
    </div>
    <div
      class="text-chocolate-academy-600 rounded-b-sm overflow-hidden border text-left
            border-blue-academy-600 fixed bg-beige-academy-100 z-10 w-64"
      :class="{selectHide: !open}">
      <div
        class="item text-chocolate-academy-600 cursor-pointer p-2"
        v-for="currency in currencies" :key="currency"
        @click="selectCurrency(currency)">
        <div class="px-4">
           <img :src="`/images/currencies/${currency}.svg`" :alt="currency"
            class="h-6">
        </div>

      </div>
    </div>
  </div>
  <div class="pointer-events-none absolute inset-y-0
  right-0 flex items-center px-2 pt-1 text-chocolate-academy-600">
    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path d="M9.293 12.95l.707.707L15.657
      8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
    </svg>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: ['value'],

  data() {
    return {
      open: false,
      selected: this.value,
      currencies: [
        'dollar',
        'euro',
        'pound',
        'yen',
        'won',
        'rupee',
        'ruble',
        'lira',
        'hryvnia',
      ],
    };
  },

  watch: {
    authenticated() {
      if (this.authenticated) {
        this.selected = this.options.find((option) => option.code === this.$i18n.locale).name;
      }
    },

  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
    }),
  },

  methods: {
    selectCurrency(currency) {
      this.selected = currency;
      this.open = false;
      this.$emit('input', currency);
    },
  },
};
</script>

<style scoped>

.item:hover {
  background-color: #E4F7F5;
  color: #B3D9E5;
}

.selectHide {
  display: none;
}
</style>
